import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import ImmobiliareContent from "../components/ImmobiliareContent";
import { canAccessImmobiliare } from "../utils/immobiliareAccess";

export default function Immobiliare() {
  const { token, user, activeStruttura } = useAuth();

  if (user && !canAccessImmobiliare(user)) {
    return <Navigate to="/" replace />;
  }

  return (
    <ImmobiliareContent
      key={activeStruttura?.id}
      token={token}
      userInfo={{
        name: user?.name,
        email: user?.email,
        telefono: user?.telefono,
      }}
    />
  );
}
